import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
// import Button from '@mui/material/Button';
// import MenuItem from '@mui/material/MenuItem';
import logo from '../assets/icons/logo.png';
import { Button, Link, Modal, Slide } from '@mui/material';
import { config } from '../config';
import startupindia from '../assets/images/startupindia-logo-whitebg.png'
import React, { useState, useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";

const pages = [
  {
    name: 'Home',
    to: '/'
  },
  {
    name: 'Services',
    to: '/#services'
  },
  // {
  //   name: 'Products',
  //   to: '/#products'
  // },
  // {
  //   name: 'FAQ',
  //   to: '/#faq'
  // },
  // {
  //   name: 'Blog',
  //   to: '/blog'
  // },
  {
    name: 'Careers',
    to: '/careers'
  },
  {
    name: 'Contact',
    to: '#footer'
  }
];

const navBarHeight = config.navbarHeight


const StartupLogo = ()=>{
  return(
    <Box
      onClick={() => {
          window.location.href='https://www.startupindia.gov.in'
        }}
        component='img'
      alt="logo"
      src={startupindia}
      sx={{ 
        width: '150px',
        objectFit: 'cover',
      }}
    />
  )
}

const CompanyLogo = () => {
  return(
    <Box
      onClick={() => {
          window.location.href='/'
        }}
        component='img'
      alt="logo"
      src={logo}
      sx={{ 
        objectFit: 'cover',
        width: '150px'
      }}
    />
  )
}


export default function Appbar() {
  const [scrolled, setScrolled] = useState(false);
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const [navMenuOpen, setNavMenuOpen] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      setNavMenuOpen(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      animate={{
        width: scrolled ? (isLg ? "1280px" : "100%") : "100%",
        top: scrolled ? (isLg ? 20 : 0) : 0,
      }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      style={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
      }}
    >

    <Box
      sx={{
        width: '100%',
        height: navBarHeight,
        backgroundColor: 'white',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        zIndex: 1000,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        alignItems: 'center',
        borderRadius:{
          md: scrolled ? (isLg ? '20px' : 0) : 0
        }        
      }}
    >
      <Toolbar disableGutters 
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: 'lg',
        margin: 'auto'
      }}
      >
        <Box sx={{ display: { 
          xs: 'flex', 
          sm: 'flex', 
          md: 'none'
         }, 
          width: '33%'
         }}>
          <IconButton
            color='primary'
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={() => {
              setNavMenuOpen(1);
            }}
          >
            <MenuIcon />
          </IconButton>
          <Modal open={navMenuOpen} onClose={handleClose}>
            <Slide
              direction="right"
              in={navMenuOpen}
              mountOnEnter
              unmountOnExit
            >
              <Box
                position="fixed"
                sx={{
                  backgroundColor: 'white',
                  left: 0,
                  width: 'max-content',
                  padding: 2,
                  paddingTop: 5,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {pages.map((page) => (
                  <Button
                    key={page.to}
                    href={page.to}
                    sx={{marginY: '3%'}}
                    onClick={()=>{setNavMenuOpen()}}
                  >
                    <Typography variant=''>{page.name}</Typography>
                  </Button>
                ))}
              </Box>
            </Slide>
          </Modal>
        </Box>

        

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '33%',
            justifyContent: {
              xs: 'center',
              sm: 'center',
              md: 'left',
            }
          }}
        >
          <CompanyLogo/>
        </Box>

        <Box
          sx={{
            display: {
              xs: 'flex',
              sm: 'flex',
              md: 'none'
            },
            flexDirection: 'row',
            width: '33%',
            justifyContent: 'right',
          }}
        >
          <StartupLogo />
        </Box>

        <Box
          sx={{
            flexDirection: 'row',
            width: '33%',
            display: { 
              xs: 'none', 
              sm: 'none', 
              md: 'flex'
            },
            justifyContent: 'center',
          }}
        >
        <Box sx={{ 
          gap: 3,
          display: 'flex',
          justifyContent: 'center',
          }}
        >
          {pages.map((page) => (
            <Link 
              color="primary" 
              key={page.name} 
              underline='hover'
              href={page.to} 
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'none',
                  color: 'primary.dark'
                },
              }}
            >
              {page.name}
            </Link>
          ))}
        </Box>
        </Box>
        <Box
          sx={{
            display: {
              xs: 'none',
              sm: 'none',
              md: 'flex',
              lg: 'flex'
            },
            flexDirection: 'row',
            width: '33%',
            justifyContent: 'right',
          }}
        >
          <StartupLogo />
        </Box>

       
      </Toolbar>
    </Box>
    </motion.div>
  );
}
